import React from 'react'

const MovieItem = ({ item }) => {
    const baseUrl = "https://image.tmdb.org/t/p/w500/";
    return (
        <div className="column">
            <img src={`${baseUrl}${item.poster_path}`} alt="Movie" />
            {/* <h2>{item.name}</h2> */}
            <h3>Rating : {item.vote_average}</h3>

        </div>
    )
}

export default MovieItem